import React, { FC } from 'react';
import empty, { EmptyProps } from 'antd/lib/empty';

import { Empty as StyledEmpty } from './styled';

export const Empty: FC<EmptyProps> = props => (
  <StyledEmpty image={empty.PRESENTED_IMAGE_SIMPLE} {...props} />
);
